<template>
	<div>
		<v-navigation-drawer
			:width="width"
			right
			temporary
			v-model="value"
			fixed
			:stateless="true"
		>
			<section class="header-modal" :style="`background-color: ${headerColor}`">
				<header class="header-title">
					<h2>{{ title }}</h2>
					<div>
						<slot name="options"></slot>
						<v-btn
							@click="closeDrawer"
							icon
							:disabled="isLoading">
							<v-icon class="iconClose" color="#03A89E !important">logout</v-icon>
						</v-btn>
					</div>
				</header>
			</section>
			<section class="content-modal">
				<slot></slot>
			</section>
		</v-navigation-drawer>
	</div>
</template>

<script>
function closeDrawer() {
	this.$emit('close-modal', false);
}

export default {
	name: 'action-sidebar',
	methods: {
		closeDrawer,
	},
	model: {
		prop: 'value',
		event: 'close-modal',
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		value: {
			type: Boolean,
			required: true,
		},
		width: {
			type: Number,
			default: 600,
		},
		codeAction: {
			type: String,
			required: false,
		},
		imgSrc: {
			type: String,
		},
		headerColor: {
			type: String,
			default: 'white',
		},
		isLoading: {
			default: false,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
	height: 100%;
	padding: 0;
}

.header-modal {
	border: 1px solid map-get($colors, grey);
	height: 39px;
	padding-left: 30px;

	.header-title {
		@include flex-between;
		width: 100%;
		color: map-get($colors, sidebar);

		h2 {
			color: map-get($colors, paginationText);
			font-family: map-get($fonts, open-semibold);
			font-size: map-get($sizes, medium20);
			text-transform: uppercase;
		}

		.v-btn {
			margin: 0;
			background-color:white;
			height:35px;
			width:35px;
		}
	}
}

.content-modal {
	background-color: map-get($colors, background-table);
	height: calc(100vh - 39px);
	overflow: auto;
	padding-bottom: 55.19px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/action-sidebar.vue